export default {"src":"/_next/static/media/ToothLoss.3a47358d.svg","height":75,"width":75,"blurWidth":0,"blurHeight":0};